import script from "./AnnualLeave.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnualLeave.vue?vue&type=script&setup=true&lang=js"

import "./AnnualLeave.vue?vue&type=style&index=0&id=d79402ce&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d79402ce"]])

export default __exports__